import React from 'react';
import { lifecycleStatusBadgeClass } from '../../utils/statusStyles';

const LABELS: Record<string, string> = {
  active: 'Active',
  dormant: 'Dormant',
  archived: 'Archived',
  do_not_contact: 'Do Not Contact',
  nurturing: 'Nurturing',
  lost: 'Lost',
  paused: 'Paused',
  former: 'Former',
};

interface LifecycleStatusBadgeProps {
  status?: string | null;
}

export const LifecycleStatusBadge: React.FC<LifecycleStatusBadgeProps> = ({ status }) => {
  const value = (status || 'active').toLowerCase();
  return <span className={lifecycleStatusBadgeClass(value)}>{LABELS[value] || value}</span>;
};
